<template>
    <div class="d-flex flex-column flex-1">
        <BPagination
            v-model="local_page"
            :total-rows="total"
            :per-page="limit"
            @update:model-value="pageChanged"
        ></BPagination>
    </div>
</template>

<script>

import {
    BTable,
    BPagination,
} from 'bootstrap-vue-next';

export default {
    name: "pagination",
    components : {
        BPagination
    },
    
    props: {
        total: {
            type: Number,
            required: true
        },
        limit: {
            type: Number,
            default: 30
        },
        current: {
            type: Number,
            default: 1
        }
    },
    
    data() {
        return {
            local_page: this.current
        };
    },
    
    watch: {
        current(val) {
            this.local_page = val;
        }
    },
    
    methods: {
        pageChanged(page) {
            console.log('pagu',page);
            
            const start = (page - 1) * this.limit;
            this.$emit('page-change', { page, start });
        }
    }
};
</script>

<style scoped>
</style>
